import { render, staticRenderFns } from "./left-right-layout.vue?vue&type=template&id=627248fd&scoped=true&"
import script from "./left-right-layout.vue?vue&type=script&lang=ts&"
export * from "./left-right-layout.vue?vue&type=script&lang=ts&"
import style0 from "./left-right-layout.vue?vue&type=style&index=0&id=627248fd&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "627248fd",
  null
  
)

export default component.exports